export default __webpack_public_path__ + "static/kp-f31adcb2ff4b069d58d34d965e7d3c78.svg";